 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin":"admin","agregar_categoria_admin~agregar_gasto_admin~agregar_producto_admin~agregar_venta_admin~categoria_edi~e3e3ff70":"agregar_categoria_admin~agregar_gasto_admin~agregar_producto_admin~agregar_venta_admin~categoria_edi~e3e3ff70","agregar_categoria_admin":"agregar_categoria_admin","agregar_gasto_admin~agregar_venta_admin~editar~editar_gasto_admin":"agregar_gasto_admin~agregar_venta_admin~editar~editar_gasto_admin","agregar_gasto_admin~editar_gasto_admin":"agregar_gasto_admin~editar_gasto_admin","agregar_gasto_admin":"agregar_gasto_admin","editar_gasto_admin":"editar_gasto_admin","editar":"editar","agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~mensajes~25201829":"agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~mensajes~25201829","agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~producto~9f4e564c":"agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~producto~9f4e564c","agregar_venta_admin":"agregar_venta_admin","agregar_producto_admin":"agregar_producto_admin","categoria_editar_admin~producto_editar_admin~producto_galeria_admin~venta_admin~venta_print_admin":"categoria_editar_admin~producto_editar_admin~producto_galeria_admin~venta_admin~venta_print_admin","producto_editar_admin":"producto_editar_admin","venta_admin":"venta_admin","categorias_admin~gastos_admin~gastos_print_admin~productos_admin~productos_print_admin~ventas_admin~~2b4a1a51":"categorias_admin~gastos_admin~gastos_print_admin~productos_admin~productos_print_admin~ventas_admin~~2b4a1a51","categorias_admin":"categorias_admin","gastos_admin":"gastos_admin","gastos_print_admin":"gastos_print_admin","productos_admin":"productos_admin","productos_print_admin":"productos_print_admin","ventas_admin":"ventas_admin","ventas_no_stock_admin":"ventas_no_stock_admin","ventas_print_admin":"ventas_print_admin","categoria_editar_admin":"categoria_editar_admin","mensajes_admin":"mensajes_admin","producto_galeria_admin":"producto_galeria_admin","venta_print_admin":"venta_print_admin","inicio":"inicio","login":"login"}[chunkId]||chunkId) + "." + {"admin":"c856aa32","agregar_categoria_admin~agregar_gasto_admin~agregar_producto_admin~agregar_venta_admin~categoria_edi~e3e3ff70":"ea953ee8","agregar_categoria_admin":"caa7a87d","agregar_gasto_admin~agregar_venta_admin~editar~editar_gasto_admin":"0589d8ad","agregar_gasto_admin~editar_gasto_admin":"9956496c","agregar_gasto_admin":"973d9aaa","editar_gasto_admin":"3b10b001","editar":"e7c94a55","agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~mensajes~25201829":"d713f383","agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~producto~9f4e564c":"bb2c0141","agregar_venta_admin":"90ec1023","agregar_producto_admin":"30acb3e9","categoria_editar_admin~producto_editar_admin~producto_galeria_admin~venta_admin~venta_print_admin":"bbc078c6","producto_editar_admin":"3584a1f2","venta_admin":"afa82f96","categorias_admin~gastos_admin~gastos_print_admin~productos_admin~productos_print_admin~ventas_admin~~2b4a1a51":"7a61a524","categorias_admin":"ba296a68","gastos_admin":"4acfab8d","gastos_print_admin":"66328dc8","productos_admin":"8b6fd7da","productos_print_admin":"0dede97b","ventas_admin":"282690a0","ventas_no_stock_admin":"501a3ec0","ventas_print_admin":"bf76e1db","categoria_editar_admin":"a8456c8b","mensajes_admin":"353b0672","producto_galeria_admin":"5c8095ad","venta_print_admin":"45d9a29a","inicio":"1ad5969e","login":"19ebce3e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin":1,"agregar_categoria_admin~agregar_gasto_admin~agregar_producto_admin~agregar_venta_admin~categoria_edi~e3e3ff70":1,"agregar_gasto_admin~editar_gasto_admin":1,"agregar_gasto_admin":1,"editar_gasto_admin":1,"editar":1,"agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~mensajes~25201829":1,"agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~producto~9f4e564c":1,"agregar_venta_admin":1,"agregar_producto_admin":1,"categoria_editar_admin~producto_editar_admin~producto_galeria_admin~venta_admin~venta_print_admin":1,"producto_editar_admin":1,"venta_admin":1,"categorias_admin~gastos_admin~gastos_print_admin~productos_admin~productos_print_admin~ventas_admin~~2b4a1a51":1,"gastos_admin":1,"gastos_print_admin":1,"ventas_admin":1,"ventas_no_stock_admin":1,"ventas_print_admin":1,"mensajes_admin":1,"venta_print_admin":1,"inicio":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin":"admin","agregar_categoria_admin~agregar_gasto_admin~agregar_producto_admin~agregar_venta_admin~categoria_edi~e3e3ff70":"agregar_categoria_admin~agregar_gasto_admin~agregar_producto_admin~agregar_venta_admin~categoria_edi~e3e3ff70","agregar_categoria_admin":"agregar_categoria_admin","agregar_gasto_admin~agregar_venta_admin~editar~editar_gasto_admin":"agregar_gasto_admin~agregar_venta_admin~editar~editar_gasto_admin","agregar_gasto_admin~editar_gasto_admin":"agregar_gasto_admin~editar_gasto_admin","agregar_gasto_admin":"agregar_gasto_admin","editar_gasto_admin":"editar_gasto_admin","editar":"editar","agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~mensajes~25201829":"agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~mensajes~25201829","agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~producto~9f4e564c":"agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~producto~9f4e564c","agregar_venta_admin":"agregar_venta_admin","agregar_producto_admin":"agregar_producto_admin","categoria_editar_admin~producto_editar_admin~producto_galeria_admin~venta_admin~venta_print_admin":"categoria_editar_admin~producto_editar_admin~producto_galeria_admin~venta_admin~venta_print_admin","producto_editar_admin":"producto_editar_admin","venta_admin":"venta_admin","categorias_admin~gastos_admin~gastos_print_admin~productos_admin~productos_print_admin~ventas_admin~~2b4a1a51":"categorias_admin~gastos_admin~gastos_print_admin~productos_admin~productos_print_admin~ventas_admin~~2b4a1a51","categorias_admin":"categorias_admin","gastos_admin":"gastos_admin","gastos_print_admin":"gastos_print_admin","productos_admin":"productos_admin","productos_print_admin":"productos_print_admin","ventas_admin":"ventas_admin","ventas_no_stock_admin":"ventas_no_stock_admin","ventas_print_admin":"ventas_print_admin","categoria_editar_admin":"categoria_editar_admin","mensajes_admin":"mensajes_admin","producto_galeria_admin":"producto_galeria_admin","venta_print_admin":"venta_print_admin","inicio":"inicio","login":"login"}[chunkId]||chunkId) + "." + {"admin":"7aba36a4","agregar_categoria_admin~agregar_gasto_admin~agregar_producto_admin~agregar_venta_admin~categoria_edi~e3e3ff70":"b93b67c3","agregar_categoria_admin":"31d6cfe0","agregar_gasto_admin~agregar_venta_admin~editar~editar_gasto_admin":"31d6cfe0","agregar_gasto_admin~editar_gasto_admin":"a7b771e1","agregar_gasto_admin":"8b1b49ff","editar_gasto_admin":"8b1b49ff","editar":"a932bbf7","agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~mensajes~25201829":"5eb3a24c","agregar_producto_admin~agregar_venta_admin~categorias_admin~gastos_admin~gastos_print_admin~producto~9f4e564c":"f084ae09","agregar_venta_admin":"a932bbf7","agregar_producto_admin":"229239ee","categoria_editar_admin~producto_editar_admin~producto_galeria_admin~venta_admin~venta_print_admin":"3114e594","producto_editar_admin":"229239ee","venta_admin":"913230b4","categorias_admin~gastos_admin~gastos_print_admin~productos_admin~productos_print_admin~ventas_admin~~2b4a1a51":"c6796266","categorias_admin":"31d6cfe0","gastos_admin":"a7b771e1","gastos_print_admin":"a7b771e1","productos_admin":"31d6cfe0","productos_print_admin":"31d6cfe0","ventas_admin":"a7b771e1","ventas_no_stock_admin":"a7b771e1","ventas_print_admin":"a7b771e1","categoria_editar_admin":"31d6cfe0","mensajes_admin":"1643a8cc","producto_galeria_admin":"31d6cfe0","venta_print_admin":"a0c67bcd","inicio":"d5e075e1","login":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
